module.exports = __webpack_public_path__ + "static/media/logo.86d618b5.svg";